/**
 * Malcriados · comparador de antes y despues.
 *
 * El control es un <input type="range"> invisible sobre la imagen: arrastrar
 * (dedo o mouse) o usar las flechas del teclado cambia su valor, y aqui ese
 * valor mueve la linea y recorta el resultado.
 */

/** @param {HTMLInputElement} rango */
function mover(rango) {
  const comparador = rango.closest('[data-mc-comp]');
  if (comparador instanceof HTMLElement) comparador.style.setProperty('--pos', `${rango.value}%`);
}

document.addEventListener('input', (evento) => {
  const rango = evento.target;
  if (rango instanceof HTMLInputElement && rango.hasAttribute('data-mc-comp-rango')) mover(rango);
});

/** @type {{ comparador: HTMLElement, id: number, caja: DOMRect, x: number, fotograma: number, movio: boolean } | null} */
let arrastre = null;
/** @type {{ comparador: HTMLElement, x: number, y: number } | null} */
let toque = null;
let ultimoArrastre = 0;

/** Pinta la linea una vez por cuadro, con la medida tomada al empezar (sin leer el diseno en cada movimiento). */
function pintar() {
  if (!arrastre) return;
  arrastre.fotograma = 0;
  const { comparador, caja, x } = arrastre;
  if (caja.width === 0) return;
  const valor = Math.round(Math.min(100, Math.max(0, ((x - caja.left) / caja.width) * 100)));
  const rango = comparador.querySelector('[data-mc-comp-rango]');
  if (rango instanceof HTMLInputElement) rango.value = String(valor);
  comparador.style.setProperty('--pos', `${valor}%`);
}

/*
 * Con el dedo solo se arrastra desde la zona de agarre de la linea; en el resto de la foto el dedo
 * desplaza el carrusel. Un toque corto en cualquier punto lleva la linea hasta ahi. Con el mouse se
 * puede arrastrar desde cualquier punto de la foto.
 */
document.addEventListener('pointerdown', (evento) => {
  const origen = evento.target instanceof Element ? evento.target : null;
  const comparador = origen?.closest('[data-mc-comp]');
  if (!(comparador instanceof HTMLElement) || (evento.pointerType === 'mouse' && evento.button !== 0)) return;
  /* En el carrusel de La prueba, un ejemplo a medias se toca para traerlo al frente: no se arrastra. */
  const par = comparador.closest('.mc-pdp-prueba__par');
  if (par && !par.classList.contains('activa') && par.parentElement?.hasAttribute('data-mc-tocar')) return;
  const agarre = origen?.closest('[data-mc-comp-agarre]');
  if (agarre || evento.pointerType === 'mouse') {
    const objetivo = agarre ?? comparador;
    objetivo.setPointerCapture(evento.pointerId);
    arrastre = { comparador, id: evento.pointerId, caja: comparador.getBoundingClientRect(), x: evento.clientX, fotograma: 0, movio: false };
    pintar();
    evento.preventDefault();
  } else {
    toque = { comparador, x: evento.clientX, y: evento.clientY };
  }
});

document.addEventListener('pointermove', (evento) => {
  if (!arrastre || evento.pointerId !== arrastre.id) return;
  arrastre.x = evento.clientX;
  arrastre.movio = true;
  if (!arrastre.fotograma) arrastre.fotograma = requestAnimationFrame(pintar);
});

document.addEventListener('pointerup', (evento) => {
  if (arrastre && evento.pointerId === arrastre.id) {
    if (arrastre.movio) ultimoArrastre = Date.now();
    cancelAnimationFrame(arrastre.fotograma);
    arrastre.x = evento.clientX;
    pintar();
    arrastre = null;
  } else if (toque && Math.hypot(evento.clientX - toque.x, evento.clientY - toque.y) < 8) {
    arrastre = { comparador: toque.comparador, id: -1, caja: toque.comparador.getBoundingClientRect(), x: evento.clientX, fotograma: 0, movio: false };
    pintar();
    arrastre = null;
  }
  toque = null;
});

document.addEventListener('pointercancel', () => {
  if (arrastre) cancelAnimationFrame(arrastre.fotograma);
  arrastre = null;
  toque = null;
});

/* Despues de arrastrar la linea, el "click" que sigue no debe mover el carrusel ni activar nada. */
document.addEventListener(
  'click',
  (evento) => {
    if (Date.now() - ultimoArrastre < 400 && evento.target instanceof Element && evento.target.closest('[data-mc-comp]')) {
      evento.stopImmediatePropagation();
      evento.preventDefault();
    }
  },
  true
);

/* Si el navegador conserva el valor al volver atras o recargar, la linea lo sigue. */
function iniciar() {
  for (const rango of document.querySelectorAll('[data-mc-comp-rango]')) {
    if (rango instanceof HTMLInputElement) mover(rango);
  }
}

iniciar();
document.addEventListener('shopify:section:load', iniciar);
window.addEventListener('pageshow', iniciar);

/* ------------------------------------------------------------
 * Pestañas por grupo (La prueba): cada pestaña muestra todos los ejemplos de su grupo.
 * ------------------------------------------------------------ */

/** @param {Element} cuerpo */
function pistaDe(cuerpo) {
  return /** @type {HTMLElement | null} */ (cuerpo.querySelector('[data-mc-pista]'));
}

/** @param {Element} cuerpo */
function actualizarFlechas(cuerpo) {
  const visibles = Array.from(pistaDe(cuerpo)?.children ?? []).filter((li) => li instanceof HTMLElement && !li.hidden);
  const flechas = cuerpo.querySelector('[data-mc-grupo-flechas]');
  if (flechas instanceof HTMLElement) flechas.hidden = visibles.length < 2;
}

/**
 * @param {Element} cuerpo
 * @param {string} grupo
 */
function mostrarGrupo(cuerpo, grupo) {
  for (const boton of cuerpo.querySelectorAll('[data-mc-grupo]')) {
    boton.setAttribute('aria-pressed', String(boton.getAttribute('data-mc-grupo') === grupo));
  }
  const pista = pistaDe(cuerpo);
  if (!pista) return;
  for (const li of pista.children) {
    if (li instanceof HTMLElement) li.hidden = li.getAttribute('data-grupo') !== grupo;
  }
  pista.scrollTo({ left: 0 });
  actualizarFlechas(cuerpo);
}

document.addEventListener('click', (evento) => {
  const origen = evento.target instanceof Element ? evento.target : null;
  if (!origen) return;
  const boton = origen.closest('[data-mc-grupo]');
  if (boton) {
    const cuerpo = boton.closest('[data-mc-grupos]');
    if (cuerpo) mostrarGrupo(cuerpo, boton.getAttribute('data-mc-grupo') ?? '');
    return;
  }
  const flecha = origen.closest('[data-mc-grupo-prev], [data-mc-grupo-next]');
  if (flecha) {
    const cuerpo = flecha.closest('[data-mc-grupos]');
    const pista = cuerpo && pistaDe(cuerpo);
    const primero = pista && Array.from(pista.children).find((li) => li instanceof HTMLElement && !li.hidden);
    if (!pista || !primero) return;
    const paso = primero.getBoundingClientRect().width + 16;
    const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sentido = flecha.hasAttribute('data-mc-grupo-next') ? 1 : -1;
    pista.scrollBy({ left: sentido * paso, behavior: reducido ? 'auto' : 'smooth' });
  }
});

/* Editor de temas: al elegir un ejemplo, se abre la pestaña de su grupo. */
document.addEventListener('shopify:block:select', (evento) => {
  const bloque = evento.target instanceof Element ? evento.target : null;
  const cuerpo = bloque?.closest('[data-mc-grupos]');
  const grupo = bloque?.getAttribute('data-grupo');
  if (cuerpo && grupo) mostrarGrupo(cuerpo, grupo);
});

for (const cuerpo of document.querySelectorAll('[data-mc-grupos]')) actualizarFlechas(cuerpo);
